import type { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { env } from "./env";
import type { AuthContext } from "./features/auth";
import { routeTree } from "./routeTree.gen";

// Splittet opp i egen komponent for å unngå at hele appen rendres, og at HMR fungerer korrekt
export const router = createRouter({
  basepath: env.appBasePath,
  routeTree,
  defaultPreload: "intent",
  scrollRestoration: true,
  scrollToTopSelectors: [],
  context: {
    auth: {} as AuthContext,
    queryClient: {} as QueryClient,
  },
});
export type AppRouter = typeof router;

declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}
